export default __webpack_public_path__ + "static/media/10.73602352.PNG";